module.exports = __webpack_public_path__ + "static/media/PA-Icon-Stra├Яenbahn-neg.b592b7da.svg";